import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';  
import 'bootstrap/dist/css/bootstrap.min.css';
 

const Industries = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const slideTimer = useRef(null);

  // Added the specific paths to each data object
const industryItems = [
  {
    name: "Manufacturing Solutions",
    path: "/manufacturing-solutions",
    image: "./images/manufacturing-solutions.jpg"
  },
  {
    name: "Healthcare and Biotech Solutions",
    path: "/healthcare-and-biotech-solutions",
    image: "./images/healthcare-and-biotech-solutions.jpg"
  },
  {
    name: "Automotive Solutions",
    path: "/automotive-solutions",
    image: "./images/automotive-solutions.jpg"
  },
  {
    name: "High Tech Solutions",
    path: "/high-tech-solutions",
    image: "./images/high-tech-solutions.jpg"
  },
  {
    name: "Aerospace",
    path: "/aerospace",
    image: "./images/aerospace.jpg"
  },
  {
    name: "Retail and Distribution",
    path: "/retail-and-distribution",
    image: "./images/retail-and-distribution.jpg"
  },
  {
    name: "Consumer Goods",
    path: "/consumer-goods",
    image: "./images/consumer-goods.jpg"
  },
  {
    name: "Construction",
    path: "/construction",
    image: "./images/construction.jpg"
  },
  {
    name: "Media and Entertainment",
    path: "/media-and-entertainment",
    image: "./images/media-and-entertainment.jpg"
  }
];

  useEffect(() => {
    if (!isHovered) {
      slideTimer.current = setInterval(() => {
        setActiveIndex((prevIndex) => (prevIndex + 1) % industryItems.length);
      }, 3000);
    }

    return () => {
      if (slideTimer.current) clearInterval(slideTimer.current);
    };
  }, [isHovered, industryItems.length]);

  return (
    <section className="industries-section position-relative min-vh-100 overflow-hidden d-flex flex-column justify-content-between p-4 p-md-5">
      
      {/* Immersive Background Images Layer */}
      {industryItems.map((item, idx) => (
        <div
          key={idx}
          className={`fullscreen-bg-image position-absolute inset-0 transition-opacity ${activeIndex === idx ? 'opacity-100 scale-up' : 'opacity-0'}`}
          style={{ backgroundImage: `url(${item.image})` }}
        />
      ))}

      {/* Main Branding Copy Content Layout */}
      <div className="container-fluid top-content-wrapper transition-all duration-500">

        <div className="hero-text-wrapper d-flex align-items-center justify-content-center min-vh-50 py-5">
      <div className="hero-text-container position-relative">
        
        {/* Top Left Framing Bracket */}
        <div className="frame-bracket top-left"></div>

        <h1 className="agency-headline text-white font-weight-bold text-uppercase m-0">
          <span className="line-one d-block">  Our </span>
          
          <span className="line-two d-block">
            <span className="text-outline">Indu</span>
            <span className="text-accent-solid text-lime">S</span>
            <span className="text-outline">tries</span>
            <span className="text-solid">   Solutions</span>
          </span>
                    
        </h1>

        {/* Bottom Right Framing Bracket */}
        <div className="frame-bracket bottom-right"></div>
        
      </div>
    </div>

        <div className="row align-items-end mb-4">
          <div className="col-12">
            
            <h1 className="display-1 text-white text-center font-weight-black main-logo-title tracking-tighter m-0">
              {industryItems[activeIndex]?.name}
            </h1>
          </div>
        </div>

        <div className="row align-items-center justify-content-between pt-3">
          <div className="col-md-4 col-12 mb-4 mb-md-0">
             
          </div>
          
           <div className="col-md-4 col-12 d-flex justify-content-start justify-content-md-center mb-4 mb-md-0 gap-3">
           <a href={industryItems[activeIndex]?.path}>
  <button className="btn btn-dark btn-rounded px-4 py-2 text-sm d-flex align-items-center">
    Explore All Work <span className="ms-2">&#x2197;</span>
  </button>
</a>

            <a href='/contact-us' > <button className="btn btn-outline-secondary btn-rounded px-4 py-2 text-sm d-flex align-items-center bg-white text-dark border-light">
                Contact Me <span className="ml-2">&#x2197;</span>
            </button> </a>
          </div>

          <div className="col-md-3 col-12 text-md-right socials-links-grid">
            <div className="row row-cols-2 g-2">
               
            </div>
          </div>
        </div>
      </div>

      {/* Floating Interactive Bottom Slider Dock Layout */}
      <div className="container-fluid mt-auto pt-5">
        <div className="row justify-content-center">
          <div className="col-12 col-xl-10">
            <div 
              className="dock-container d-flex align-items-center justify-content-between p-3 rounded-xl backdrop-blur"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {industryItems.map((item, idx) => (
                // Changed from <div> to <Link> component
                <Link
                  key={idx}
                  to={item.path}
                  className={`dock-item-thumbnail transition-all rounded-lg overflow-hidden ${activeIndex === idx ? 'active-thumbnail' : ''}`}
                  onMouseEnter={() => setActiveIndex(idx)}
                  style={{ backgroundImage: `url(${item.image})` }}
                  title={item.name}
                >
                  {/* <span className="sr-only">{item.name}</span> */}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

    </section>
  );
};

export default Industries;